module.exports = __webpack_public_path__ + "img/elite_sand_ba_list.061170f8.jpg";